export default __webpack_public_path__ + "static/media/love.8fef6563.svg";